// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","icon":"Button_icon__Zd50D"};